import { isMobile } from 'utils'
import Vue from 'vue'

const mobileMessageAPI = (msg, type) => {
  let defaultTypes = ['success', 'warning', 'error'];
  if(type && defaultTypes.indexOf(type) > -1 ) {
    if(type === 'error') type = 'danger'
    Vue.prototype.$notify({ type: type, message: msg })
  } else {
    Vue.prototype.$notify({ type: "primary", message: msg })
  }
}

const pcMessageAPI = (msg, type) => {
  let defaultTypes = ['success', 'warning', 'error'];
  if(type && defaultTypes.indexOf(type) > -1 ) {
    Vue.prototype.$Message[type](msg)
  } else {
    Vue.prototype.$Message.info(msg)
  }
}

const messageAPI = isMobile() ? mobileMessageAPI : pcMessageAPI;

export default messageAPI